// extracted by mini-css-extract-plugin
module.exports = {"collapse":"collapse_collapse__2IUC_","active":"collapse_active__2_ERC"};